const regex = {
  phone: /^\+[0-9]{1,4}\s([0-9]{2,})/,
  phoneMinimumLength: /^\+[0-9]{1,4}\s([0-9]{2,})/,
  phoneCountryCode: /^\+[0-9]{1,4}\s([0-9]{1,})/,
  url: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
};

export { regex };
